//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

const getShouldReselectIgAccount = createSelector(
  (state: ICuralateStore) => state.facebookInstagramSettings.connectedInstagramAccount,
  (connectedInstagramAccount) => !!connectedInstagramAccount && !connectedInstagramAccount.businessAccountId,
);

export default getShouldReselectIgAccount;
